<template>
<div class="createTeam" :class="[showFlag|showDetailFlag?'noscroll':'']">
  <div class="title">
    团体信息（必填）
  </div>
  <div class="iptgroup">
    <input name="name"
           class="activityIpt"
           placeholder="输入团体名称（限15字）"
           v-model="teamname"
           data-key="teamname"
           @blur="upkeyboard"/>
  </div>
  <div class="iptgroup">
    <input name="num"
           class="activityIpt"
           placeholder="输入团体人数（限500人）"
           v-model="teamnum"
           data-key="teamnum"
           @blur="upkeyboard"
           type="number"/>
  </div>
  <div class="title">
    自定义信息（选填）
    <span class="addbtn" @click="addExtra">添加信息</span>
  </div>
  <div class="iptgroup" v-for="(item,index) in extra_information" :key="index">
    <input name="auto"
           class="activityIpt"
           @input="iptfn(index, $event)"
           :value="item"
           @blur="upkeyboard"
           :placeholder="[eglist[index]?'自定义信息'+(index+1)+' 如“'+eglist[index]+'”':'自定义信息'+(index+1)]"/>
    <img src="@/assets/del.png" class="delimg" :data-idx="index" @click="delextra(index)" />
  </div>
  <div class="iptgroup timepick" @click="showTimeFlag">
    <img src="@/assets/time.png" class="timeimg" />
    <div class="timename">{{selTime?selTime:'选择截止时间（必选）'}}</div>
    <img src="@/assets/triangle.png" class="triangleimg" />
  </div>
  <div class="ownsee">
    仅创建者可见
    <img @click="canownsee" src="@/assets/answer.png" class="answerimg" />
    <mt-switch class="switchOps" v-model="is_visible"></mt-switch>
  </div>
  <div class="foot">
    <button class="surebtn" @click="onSubmit" :class="[teamname&&teamnum&&selTime?'canOps':'']">选择规格</button>
  </div>
  <div class="suremask" v-show="sureFlag">
    <div class="surecot">
      <div class="suretitle">确认创建团体</div>
      <div class="sureinfo">
        请仔细确认您创建的团体拍证件照的信息设置，一旦提交不可修改
      </div>
      <div class="suredata">
        <div class="surelist">
          名称：{{teamname}}
        </div>
        <div class="surelist">
          规格：{{specName}}
          <span class="gan">|</span>
          <span class="surebg" :style="{'background-image': 'linear-gradient(to bottom,#'+ selColor.s_color +',#'+ selColor.e_color +')'}"></span>
        </div>
        <div class="surelist">
          信息：{{extra_information|extratxt}}
        </div>
      </div>
      <div class="surebtngroup">
        <div class="suregroupbtn"
             @click="cancelFn">取消</div>
        <div class="suregroupbtn"
             @click="sureFn">确认</div>
      </div>
    </div>
  </div>
  <datetime-picker v-if="nowTime"
                   ref="picker"
                   type="date"
                   :startDate="nowTime"
                   :endDate="endTime"
                   year-format="{value} 年"
                   month-format="{value} 月"
                   date-format="{value} 日"
                   @confirm="handleConfirm"></datetime-picker>
  <rule :showFlag="showFlag"
        :ruleTp="ruleTp"
        @onChangeKey="onChangeKey"
        @onSelType="onSelType"
        @onQuerylist="onQuerylist"
        @onRuledetail="onRuledetail"
        @goautospec="goautospec"
        @onControlRule="showFlag=false"></rule>
  <rule-detail :showFlag="showDetailFlag"
               @onControlRule="showDetailFlag=false"
               @onReturnrule="onReturnrule"
               @onSureid="onSureid"></rule-detail>
  <auto-spec :showFlag="autoRuleShow"
            @onCloseSpec="autoRuleShow=false"
            @onGomakephoto="onGomakephoto">
    <color-sel :color="background_color"
              :coloridx="colorIdx"
              :isleft="true"
              @onSetidx="onSetidx"></color-sel>
  </auto-spec>
</div>
</template>

<script>
import { Toast, Switch, MessageBox, DatetimePicker } from 'mint-ui'
import rule from '@/components/rule'
import ruleDetail from '@/components/ruleDetail/ruleDetail'
import autoSpec from '@/components/autoSpec/autoSpec'
import { mapActions, mapState, mapMutations } from 'vuex'
import colorSel from '@/components/colorSel/colorSel'
import { upkeyboard } from '@/utils/utils'
export default {
  data () {
    return {
      nowTime: null,
      endTime: null,
      teamname: '',
      teamnum: '',
      selTime: '',
      extra_information: ['', '', ''],
      eglist: ['姓名', '学号', '班级'],
      loadingTxt: '',
      showFlag: false,
      showDetailFlag: false,
      autoRuleShow: false,
      sureFlag: false,
      ruleTp: {
        keyword: '',
        rulestyle: [],
        selId: 0,
        search: {
          pageIndex: 1,
          pageTotal: 0,
          list: []
        },
        allList: [{
          pageIndex: 1,
          pageTotal: 0,
          id: 1,
          list: []
        }],
        touimg: '',
        searchStatus: 0, // 0为不显示状态图，1为没有找到规格图，2为努力加载图，3为检查网络图，4为出错图
        isLoading: false,
        isFinish: false
      },
      background_color: [],
      colorIdx: 0,
      is_visible: false,
      specName: '',
      selColor: {} // 选中的颜色
    }
  },
  deactivated () {
    this.sureFlag = false
    this.showFlag = false
    this.showDetailFlag = false
    this.autoRuleShow = false
    this.teamname = ''
    this.teamnum = ''
    this.selTime = ''
    this.extra_information = ['', '', '']
    this.$refs.picker.close()
    this.is_visible = false
    this.ruleTp.selId = 0
    this.ruleTp.keyword = ''
  },
  activated () {
    console.log('createTeam')
    if (!this.actiBol) {
      return
    }
    var nowTime = new Date()
    this.nowTime = nowTime
    var endTime = new Date(nowTime)
    endTime.setDate(endTime.getDate() + 59) // 默认60天为活动最长到期时间
    this.endTime = endTime
    this.openme()
  },
  computed: {
    ...mapState(['makePhotoInfo', 'actiBol', 'defaultColor'])
  },
  filters: {
    extratxt (arr) {
      const brr = arr.filter(item => item)
      const txt = brr.length > 0 ? brr.join('/') : '无'
      return txt
    }
  },
  components: {
    mtSwitch: Switch,
    DatetimePicker,
    rule,
    ruleDetail,
    autoSpec,
    colorSel
  },
  methods: {
    ...mapMutations(['setTeaminfo']),
    ...mapActions(['specClassifyA', 'showSpecsL', 'showSpecsA', 'getKeywordL', 'getKeywordA', 'createProA']),
    onSelType (id) {
      this.ruleTp.selId = id
      this.ruleTp.isFinish = false
      this.showClassify(id, false)
    },
    upkeyboard () {
      upkeyboard()
    },
    goautospec () {
      // 自定义规格
      console.log('自定义规格')
      this.background_color = this.defaultColor
      this.showFlag = false
      this.autoRuleShow = true
    },
    cancelFn () {
      this.sureFlag = false
    },
    onGomakephoto () {
      console.log('wrwwqr')
      const { colorIdx } = this
      const { background_color } = this.makePhotoInfo
      this.autoRuleShow = false
      this.sureFlag = true
      this.selColor = background_color[colorIdx]
      this.specName = '自定义规格'
    },
    onSetidx (idx) {
      this.colorIdx = idx
    },
    sureFn () {
      const { selColor, teamname, teamnum, selTime, is_visible, extra_information } = this
      const { spec_id, specName, height_px, width_px, ppi, file_size_max, file_size_min } = this.makePhotoInfo
      let extra_informationlist = extra_information.filter(item => item)
      const extra_informationSet = new Set(extra_informationlist)
      extra_informationlist = [...extra_informationSet]
      const data = {
        project_name: teamname,
        quantity: teamnum,
        ...spec_id && {
          spec_id,
          spec_name: specName
        },
        background_color: [selColor],
        end_time: selTime,
        is_visible,
        extra_information: extra_informationlist,
        height_px,
        width_px,
        dpi: ppi,
        file_size_max,
        file_size_min
      }
      this.setTeaminfo(data)
      this.createProA().then(res => {
        this.sureFlag = false
        Toast({
          message: '创建成功',
          duration: 1000
        })
        setTimeout(() => {
          this.$router.replace({
            name: 'MyTeam'
          })
        }, 1000)
      })
    },
    onSureid () {
      const { specName, background_color, colorIdx } = this.makePhotoInfo
      console.log('background_color:::', this.makePhotoInfo)
      this.showDetailFlag = false
      this.sureFlag = true
      this.specName = specName
      this.selColor = background_color[colorIdx]
    },
    onRuledetail (id) {
      this.$bus.emit('openActiwrap', id, true)
      this.showFlag = false
      this.showDetailFlag = true
    },
    onQuerylist () {
      const name = this.ruleTp.keyword !== '' ? 'scrollKey' : 'showClassify'
      const { selId } = this.ruleTp
      const obj = {
        showClassify: () => {
          this.showClassify(selId, true)
        },
        scrollKey: () => {
          this.scrollKey()
        }
      }
      console.log(name)
      obj[name].call(this)
    },
    showClassify (id, pullbol) {
      const { allList } = this.ruleTp
      const listobj = allList[id.toString()]
      const { pageIndex, pageTotal, isFinish } = listobj
      if (isFinish) {
        this.ruleTp.isFinish = true
        return
      }
      if (pullbol && pageIndex > pageTotal) {
        // 滑动获取数据判断是否不可获取数据了
        listobj.isFinish = true
        this.ruleTp.allList.splice(id, 1, listobj)
        this.ruleTp.isFinish = true
        return
      }
      // 滑动获取数据加底部loading
      if (pullbol) {
        this.ruleTp.isLoading = true
      }
      if (!pullbol && pageIndex > 1) {
        // 不是滑动获取数据要判断有没有数据了，有就不获取了
        return
      }
      const httpname = pullbol ? this.showSpecsA : this.showSpecsL // 每个规格首次加载加入loading
      httpname({ id, pageIndex }).then(res => {
        if (res === 'wrong') {
          this.ruleTp.searchStatus = 4
          this.ruleTp.isLoading = false
          return
        }
        const { total_paging, specs } = res
        console.log(res)
        listobj.pageIndex++
        listobj.pageTotal = total_paging
        const finishbol = total_paging < listobj.pageIndex
        listobj.isFinish = finishbol
        console.log('specs:::', specs)
        listobj.list = [...(listobj.list), ...specs]
        this.ruleTp.isLoading = false
        this.ruleTp.isFinish = finishbol
        this.ruleTp.searchStatus = 0
        // 滑动获取的数据添加
        this.ruleTp.allList.splice(id, 1, listobj)
      })
    },
    onReturnrule () {
      this.showFlag = true
      this.showDetailFlag = false
    },
    scrollKey () {
      const { keyword, isFinish, search } = this.ruleTp
      let { pageIndex, pageTotal, list } = search
      if (isFinish) {
        return
      }
      if (pageIndex > pageTotal) {
        this.ruleTp.isFinish = true
        return
      }
      this.ruleTp.isLoading = true
      this.getKeywordA({ pageIndex, key: keyword }).then(res => {
        const { total_paging, specs } = res
        pageIndex++
        const len = list.length
        this.ruleTp.search.list.splice(len, 0, ...specs)
        this.ruleTp.isLoading = false
        this.ruleTp.search.pageIndex = pageIndex
      })
    },
    openme () {
      this.specClassifyA().then(res => {
        const typerule = res.result
        const objarr = this.initallist(typerule)
        this.eight2one(typerule, objarr)
      })
    },
    eight2one (tl, objarr) {
      const count = 8
      const arr = []
      tl.forEach((item, idx) => {
        const index = parseInt(idx / count)
        arr[index] = arr[index] ? arr[index] : []
        arr[index].push(item)
      })
      const defaultval = tl[0] ? tl[0] : {}
      this.ruleTp.rulestyle = arr
      this.ruleTp.allList = objarr
      this.showClassify(defaultval.id, false)
    },
    initallist (arr) {
      const { allList } = this.ruleTp
      if (allList.length > 1) {
        console.log('无需在操作')
        return allList
      }
      // 初始化alllist
      const objarr = [] // 不用obj是为了让splice更好的数据更新页面因为key值不能有变量
      arr.forEach((item, idx) => {
        const id = item.id
        objarr[id] = {
          pageIndex: 1,
          pageTotal: 0,
          id,
          name: item.name,
          isFinish: false,
          idx,
          list: []
        }
      })
      return objarr
    },
    addExtra () {
      const len = this.extra_information.length
      if (len >= 10) {
        Toast('自定义信息不能超过10个哟~')
        return
      }
      this.extra_information.push('')
    },
    onSubmit () {
      var { teamname, teamnum, selTime } = this
      if (!teamname || !teamnum || !selTime) {
        return
      }
      if (teamname.length > 15) {
        MessageBox.alert('团体名称要少于15字哟~')
        return
      }
      if ((!/^\d+$/.test(teamnum) || teamnum > 500 || teamnum <= 0)) {
        MessageBox.alert('团队人数要在0到500内哟~')
        return
      }
      this.showFlag = true
    },
    iptfn (idx, e) {
      const val = e.target.value
      console.log(idx, val)
      this.extra_information[idx] = val
    },
    delextra (idx) {
      console.log('索引::', idx)
      this.extra_information.splice(idx, 1)
    },
    canownsee () {
      MessageBox({
        title: '仅创建者可见',
        message: '开启该功能时，支持创建者给多人拍照，可批量下载',
        confirmButtonText: '我知道了'
      })
    },
    showTimeFlag () {
      this.$refs.picker.open()
    },
    handleConfirm (e) {
      var time = new Date(e)
      this.selTime = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`
    },
    onChangeKey (key) {
      this.ruleTp.keyword = key
      this.ruleTp.searchStatus = 0
      this.ruleTp.isFinish = false
      key !== '' && this.getKeywordL({ pageIndex: 1, key }).then(res => {
        const { specs, total_paging } = res
        this.ruleTp.search.pageIndex = 2
        this.ruleTp.search.pageTotal = total_paging
        if (specs.length === 0) {
          this.ruleTp.searchStatus = 1
        }
        this.ruleTp.search.list = specs
      })
    }
  }
}
</script>

<style>
.createTeam .mint-switch-input:checked + .mint-switch-core {
  border-color: #4710ED;
  background-color: #4710ED;
}
</style>

<style scoped>
.createTeam{
  padding:0 0.4rem;
  box-sizing: border-box;
  min-height: 100%;
}
.noscroll {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.title{
  color:#303133;
  font-size: 0.32rem;
  font-weight: bold;
  margin:.4rem 0 .2rem;
}
.surebg{
  width:.32rem;
  height:.32rem;
  border-radius: .06rem;
  display: inline-block;
  vertical-align: text-bottom;
  margin-left: 0.5em;
}
.gan{
  vertical-align: text-bottom;
  margin-left: 0.5em;
}
.iptgroup{
  width:100%;
  height:.92rem;
  border:.02rem solid #E5E5EA;
  border-radius: .12rem;
  margin:0 auto .16rem;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.delimg{
  width:.48rem;
  height:.48rem;
  flex-shrink: 0;
  margin:0 .32rem;
  border:.1rem solid transparent;
}
.activityIpt{
  width:100%;
  height:100%;
  border:none;
  padding-left: 1em;
  font-size: .3rem;
  flex-grow: 1;
  background-color: transparent;
}
.addbtn{
  color:#4710ED;
  font-size: .28rem;
  float:right;
  padding:.1rem;
}
.timepick{
  margin:.48rem auto .54rem;
  padding:0 .32rem;
  box-sizing: border-box;
}
.timeimg,.triangleimg,.answerimg{
  width:.32rem;
  height:.32rem;
  border:.1rem solid transparent;
  flex-shrink: 0;
}
.timename{
  flex-grow: 1;
  font-size: .3rem;
  color:#303133;
}
.ownsee{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  font-size: .32rem;
  color:#303133;
  flex-shrink: 0;
  margin-bottom: 1.60rem;
}
.switchOps{
  flex-grow: 1;
  direction: rtl;
}
.foot{
  position: fixed;
  width: 100%;
  background-color: white;
  bottom:0;
  left:0;
}
.surebtn{
  width:6.86rem;
  height:.96rem;
  display: block;
  border: none;
  background-color: #F2F2F2;
  text-align: center;
  font-size: .34rem;
  line-height: .96rem;
  border-radius: .12rem;
  color:#D6D6D7;
  margin:.32rem auto;
}
.canOps{
  background-color: #4710ED;
  color:white;
}
.suremask{
  width:100%;
  height:100%;
  position:fixed;
  top:0;
  left:0;
  z-index: 1;
  background-color:rgba(0,0,0,0.4);
}
.surecot{
  width:5.6rem;
  background-color: #FFFFFF;
  border-radius: .06rem;
  position: absolute;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
  transform: -webkit-translate(-50%,-50%);
  padding-top: .48rem;
  font-size: .26rem;
  color:#838485;
}
.suretitle{
  font-size: .34rem;
  color:#303133;
  text-align: center;
  font-weight: bold;
  margin-bottom: .16rem;
}
.sureinfo{
  text-align: center;
  margin-bottom: .32rem;
  padding:0 .48rem;
}
.suredata{
  background-color: #F5F7FA;
  border-radius: .16rem;
  margin:0 .48rem .44rem;
  box-sizing: border-box;
  padding:.24rem;
  color: #303133;
  font-size: .24rem;
}
.surelist{
  word-break: break-all;
  margin-left: 3em;
  text-indent: -3em;
  line-height: .32rem;
}
.surebtngroup{
  border-top:.02rem solid rgba(25, 31, 37, 0.08);
  display: flex;
  display: -webkit-flex;
  height:.86rem;
  font-size: .34rem;
  color:#303133;
}
.suregroupbtn{
  flex-grow: 1;
  text-align: center;
  line-height: .86rem;
}
.suregroupbtn:first-child{
  border-right: .02rem solid rgba(25, 31, 37, 0.08);
}
.activebtn{
  background-color: #ccc;
  color:white;
}
</style>
